<template lang="pug">
div
  v-menu(v-model="show" rounded="lg" :close-on-content-click="false" offset-y max-height="345" max-width="320")
    template(#activator="{ on }")
      v-sheet.round-md.clickable.border-menu(flat outlined @click="fetchIndication" :height="height" :class="`text-${[size]}`")
        v-row.fill-height(no-gutters align="center")
          v-col.pl-3
            div.ellipsis-text(v-if="value" :class="`text-${[size]}`") {{ value }}
            .text-sm.neutral400--text(v-else) Indication
          v-col.shrink.pr-3(v-if="isFetching")
            v-progress-circular.ma-auto(:width="2" :size="15" color="primary" indeterminate)
          v-col.shrink.pr-2(v-else)
            v-icon(size=20 style="margin-top: 2px;") $yzi-chevron-down
    .text-xs.white
      .search-input
        v-text-field.mb-2.mx-4.text-sm.round-xl(v-model="itemName" outlined :placeholder="$t('search_or_add_new')" dense hide-details autofocus clearable @input="searchStart" @keyup.enter="onAddItem")
        template(v-if="showAddButton")
          .text-xxs.px-4.italic.mb-2 Hit 
            span.font-semibold.danger500--text ENTER 
            | to add indication
            br
            span.font-semibold '{{ $options.filters.truncate(itemName, 35) }}'
            br
            | or click 
            span.font-semibold.clickable.underline(@click="onAddItem") HERE
        v-divider
      div.d-flex.justify-center(v-if="isFetching")
        v-progress-linear(:width="3" rounded color="primary" indeterminate)
      .d-flex.align-center.justify-space-between.px-4.py-3
        .font-semibold.mr-6 Existing indication
        y-pagination(v-model="page" :pageSize="pageSize" :count="count" :loading="isFetching" @input="pageChanged") 
      div(v-for="item in indications" @click="onSelectItem(item)")
        div.font-normal.pa-4.hover-bg.clickable(:class="`text-${[size]}`") {{ item.value }}
        v-divider
      template(v-if="!indications.length")
        .px-4.py-3 {{ $t('no_result_match') }}
</template>

<script>
import { debounce } from '@/utils'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: 'sm'
    }
  },
  data: () => ({
    isFetching: false,
    show: false,
    itemName: null,
    page: 1,
    pageSize: 10,
    count: 0,
    indications: [],
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
      hqSelectedCompany: 'hq/getSelectedCompany',
      isHq: 'hq/getIsHq'
    }),
    height () {
      switch (this.size) {
        case 'xxs':
          return 28
        case 'xs':
          return 32
        case 'sm':
          return 36
        case 'md':
          return 40
        default:
          return 36
      }
    },
    iconSize () {
      switch (this.size) {
        case 'xxs':
          return 12
        case 'xs':
          return 16
        case 'sm':
          return 20
        case 'md':
          return 24
        default:
          return 20
      }
    },
    showAddButton() {
      if (this.itemName && this.indications.every(indication => indication.value.toLowerCase() !== this.itemName.toLowerCase())) {
        return true
      }
      return false
    },
  },
  watch: {},
  methods: {
    ...mapActions(['showMessage']),
    fetchIndication() {
      this.isFetching = true
      let params = {
        enabled: true,
        page: this.page,
        page_size: this.pageSize,
        company: this.isHq ? this.hqSelectedCompany.id : this.company.id,
        field: 'medication.indication',
        search: this.itemName || null
      }
      this.$axios.get('/options', { params })
        .then(resp => {
          this.indications = resp.data.results
          this.count = resp.data.count
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.show = true
          this.isFetching = false
        })
    },
    searchStart: debounce(function () {
      this.page = 1
      this.fetchIndication()
    }, 750),
    pageChanged () {
      this.fetchIndication()
    },
    onSelectItem (item) {
      this.$emit('input', item.value)
      this.$emit('change', item.value)
      this.show = false
    },
    onAddItem () {
      this.$emit('input', this.itemName)
      this.$emit('change', this.itemName)
      this.show = false
    },
  }
}
</script>

<style scoped>
.border-menu {
  border: 1px solid var(--v-basic500);
  box-shadow: none;
}
.error-border-menu {
  border: 1px solid var(--v-danger500);
  box-shadow: none;
}
.search-input {
  position: sticky;
  top: 0px;
  background-color: #FFFFFF !important;
  border-color: #FFFFFF !important;
  z-index: 4;
  padding-top: 8px;
}
.disabled-item {
  background-color: var(--v-neutral300);
  color: var(--v-neutral500);
}
.ellipsis-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
</style>